import MultiSelectComboBox from './MultiSelectComboBox';

export default MultiSelectComboBox;
